import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { DashboardPanelLayout } from './layout';
export const DashboardPanel = (Panel, layout_props = { can_hide: true }) => memo(function DashboardPanel(props) {
    const { panel_key } = props;
    const { can_hide = true } = layout_props;
    return (_jsx(DashboardPanelLayout, { panel_key: panel_key, can_hide: can_hide, children: _jsx(Panel, { ...props }) }));
});
